import React, { Component } from 'react';

import config from './Button.component.config';
import './Button.less';
class Button extends Component {
  stringMatch = (str, find) => {
    const strRegExPattern = `\\b${find}\\b`;
    return str.match(new RegExp(strRegExPattern, 'g'));
  };

  mainAction = e => {
    e.stopPropagation();
    e.preventDefault();
    this.props.action();
  };

  render() {
    const { addClass, children, style } = this.props;
    let isBtnDisable = null;
    if (addClass) {
      isBtnDisable = this.stringMatch(addClass, 'inactive');
    }
    return (
      <button
        id={this.props.id}
        type="button"
        className={`button ${addClass === undefined ? 'primary' : addClass}`}
        onClick={this.mainAction}
        style={style}
        {...{ disabled: isBtnDisable !== null ? 'disabled' : '' }}
      >
        {children}
      </button>
    );
  }
}

Button.displayName = config.displayName;
Button.propTypes = config.propTypes;
Button.defaultProps = config.defaultProps;

export default Button;
